module.exports = __webpack_public_path__ + "img/1.86cd3ce3.jpg";